define((require) => {
    "use strict";

    const ExperienceViewModel = require("shared/ui/viewer/ExperienceViewModel");

    /**
     * View model for the experience viewer.
     *
     * @class ExperienceViewModel
     * @constructor
     */
    return ExperienceViewModel.extend("TemplateViewModel", {
        defaults: {
            /**
             * @type {null|String}
             * template identificator and
             * same time this is marker of Template usage
             */
            templateId: null
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/TemplateViewModel.js